import { useContext, useEffect, useRef, useState } from 'react'
import { SocketContext } from '../../../context/provider/SocketProvider';
import { notify } from '../../../utils/utils';
import { useNotificaciones } from '../../../hooks/Notificaciones/useNotificaciones';

export const BotonNotificaciones = () => {
    const [ mostrarContenido, setMostrarContenido ] = useState(false);
    const [ mostrarIcono, setMostrarIcono ] = useState(false);
    const [ opcion, setOpcion ] = useState(true);
    const [ numIcono, setNumIcono ] = useState(0);
    const contenedorRef = useRef(null);
    const botonRef = useRef(null);
    const { stateSocket } = useContext(SocketContext);
    const { listarNotificaciones, notificacionPGI } = useNotificaciones();

    useEffect(()=> {
        if(Object.keys(stateSocket.payload).length > 0){
            if(stateSocket.payload.message){
                notify(stateSocket.payload.message.bd.mensaje, 'info');
                setNumIcono(i => i +1)
            }
        }
    },[stateSocket.payload])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                mostrarContenido &&
                !botonRef.current.contains(event.target) &&
                !contenedorRef.current.contains(event.target)
            ) {
                setMostrarContenido(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [mostrarContenido]);



    const clicBotonNotificacion = () => {
        setMostrarContenido(!mostrarContenido)
        setMostrarIcono(false)
    }

    return (
        <>
            <button
                ref={botonRef}
                className='hover:bg-blue-600 px-2 rounded h-[30px]'
                onClick={clicBotonNotificacion}
            >
                <i className='fa fa-bell'></i>
                {
                    !mostrarIcono && numIcono > 0 &&
                    <>
                        <span
                            className='rounded-[50%] bg-[#ff5370] absolute text-center 
                            -top-1 -right-2 w-[22px] h-[22px] p-1 inline-block text-xs font-semibold'
                        >{numIcono}</span>
                    </>
                }
            </button>
            {
                mostrarContenido &&
                <div
                    ref={contenedorRef}
                    className={`dark:bg-gray-800 absolute z-50 top-[40px] w-[300px] flex flex-col
                    transition-all duration-1000 ease-out right-[25%] min-h-[200px] max-h-[400px] rounded-xl `}
                >
                    <section
                        className='w-full m-h-[20%] flex p-1 gap-4 justify-center
                        items-center border-gray-400 border-b min-h-[40px]'
                    >
                        <button
                            className={`${opcion ? 'bg-blue-800 ' : ' hover:bg-blue-600 '}
                            min-w-[70px] max-w-[80px] min-h-[30px] rounded transition-all duration-500 ease-out`}
                            onClick={() => setOpcion(true)}
                        >No leido</button>
                        <button
                            className={`${!opcion ? ' bg-blue-600 ' : ' hover:bg-blue-800 '}
                            min-w-[70px] max-w-[80px] min-h-[30px] rounded transition-all duration-500 ease-out`}
                            onClick={()=> setOpcion(false)}
                        >Leido</button>
                    </section>
                    <section
                        className='w-full min-h-[120px] m-h-[60%] containerScroll px-2 overflow-y-auto'
                    >
                        {
                            opcion ?
                                <ul>
                                    <li className='py-2 border-gray-400 border-b'>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                </ul>
                            : 
                                <ul>
                                    <li className='py-2 border-gray-400 border-b'>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                    <li>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </li>
                                </ul>
                        }
                        {/* {
                            notificacionPGI.length > 0 &&
                            <ul>
                                {
                                    notificacionPGI.map((not, index) => (
                                        <li>
                                            <i className='fa fa-bus'></i>
                                        </li>
                                    ))
                                }

                            </ul>
                        } */}
                    </section>
                    <section
                        className='w-full min-h-[40px] m-h-[20%] border-gray-400 border-t text-center'
                    >Ver más...</section>
                </div>
            }
        </>
    )
}
























